import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Select,
  MenuItem,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Dialog,
  Autocomplete,
  TextField,
  Card,
  Box,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
//import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/es";
import weekday from "dayjs/plugin/weekday";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(weekday);
dayjs.extend(isSameOrBefore);

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";

import PermissionsApi from "api/permissions";
import DatosBasicosApi from "api/datosbasicosApi";
import SedesApi from "api/sedesApi";
import PDFApi from "api/pdfApi";
import BucketApi from "api/bucketApi";
import ProcesosApi from "api/procesosApi";
import ApoderadosApi from "api/apoderadosApi";

const ClasificarProcesoModal = ({ open, onClose, procesoIdentificador, onSuccess }) => {
  const [error, setError] = useState(undefined);
  const [proceso, setProceso] = useState(null);
  const [sedes, setSedes] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [autoAdmision, setAutoAdmision] = useState("");
  const [estadosProceso, setEstadosProceso] = useState([]);
  const [selectedSede, setSelectedSede] = useState(null);
  const [selectedEstado, setSelectedEstado] = useState(null);
  const [selectedTipoProceso, setSelectedTipoProceso] = useState(null);
  const [finalidad, setFinalidad] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [asesores, setAsesores] = useState([]);
  const [asistentes, setAsistenes] = useState([]);
  const [operadores, setOperadores] = useState([]);
  const [diasFestivos, setDiasFestivos] = useState([]);
  const [apoderados, setApoderados] = useState([]);
  const [tipoResponsable, setTipoResponsable] = useState("");
  const [responsable, setResponsable] = useState(null);
  const [respAsesor, setRespAsesor] = useState(null);
  const [respAsistente, setRespAsistente] = useState(null);
  const [respOperador, setRespOperador] = useState(null);
  const [apoderado, setApoderado] = useState(null);
  const [etiqueta, setEtiqueta] = useState("");
  const [prioridad, setPrioridad] = useState("");
  const [peso, setPeso] = useState(1);
  const [seguimiento, setSeguimiento] = useState("");
  const [fechaAdmision, setFechaAdmision] = useState(null);
  const [fechaAceptacion, setFechaAceptacion] = useState(null);
  const [fechaDesignacion, setFechaDesignacion] = useState(null);
  const [fechaValidacion, setFechaValidacion] = useState(null);
  const [fechaActuaAcreencias, setFechaActuaAcreencias] = useState(null);
  const [fechaSuspension, setFechaSuspension] = useState(null);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (procesoIdentificador) {
      const fetchInitialData = async () => {
        try {
          const [
            procesoResp,
            sedesRes,
            gruposRes,
            estadosProcesoRes,
            usuarioRes,
            asesorRes,
            asistenteRes,
            operadorRes,
            diasFestivosResp,
          ] = await Promise.all([
            ProcesosApi.fetchProcesoByIdentificador(procesoIdentificador),
            SedesApi.fetchSedes(),
            PermissionsApi.fetchGroups(),
            DatosBasicosApi.fetchEstadosProceso(),
            ProcesosApi.fetchResponsables({
              roles: [
                "ASESOR(A) EXTERNO",
                "ASESOR(A) INTERNO",
                "ASISTENTE",
                "OPERADOR(A)",
                "CARTERA",
                "COORDINADOR(A)",
              ],
            }),
            ProcesosApi.fetchResponsables({
              roles: ["ASESOR(A) EXTERNO", "ASESOR(A) INTERNO"],
            }),
            ProcesosApi.fetchResponsables({
              roles: ["ASISTENTE"],
            }),
            ProcesosApi.fetchResponsables({
              roles: ["OPERADOR(A)"],
            }),
            DatosBasicosApi.fetchDiasFestivos(),
          ]);
          setProceso(procesoResp.data);
          setSedes(Array.isArray(sedesRes.data) ? sedesRes.data : []);
          setGrupos(Array.isArray(gruposRes.data) ? gruposRes.data : []);
          setEstadosProceso(Array.isArray(estadosProcesoRes.data) ? estadosProcesoRes.data : []);
          setUsuarios(Array.isArray(usuarioRes.data) ? usuarioRes.data : []);
          setAsesores(Array.isArray(asesorRes.data) ? asesorRes.data : []);
          setAsistenes(Array.isArray(asistenteRes.data) ? asistenteRes.data : []);
          setOperadores(Array.isArray(operadorRes.data) ? operadorRes.data : []);
          setDiasFestivos(Array.isArray(diasFestivosResp.data) ? diasFestivosResp.data : []);
        } catch (error) {
          console.error("Error al obtener los datos iniciales:", error);
          setError(obtenerMensajeError(error, "Error al cargar los datos iniciales."));
        }
      };

      fetchInitialData();
    }
  }, [procesoIdentificador]);

  const fetchDatosProceso = async (proceso) => {
    const apoderadosRes = await ApoderadosApi.fetchApoderadosCliente(proceso.cliente);
    setApoderados(Array.isArray(apoderadosRes.data) ? apoderadosRes.data : []);
    // Datos del Proceso
    setAutoAdmision(proceso.auto_admision);
    setSelectedSede(proceso.sede_detalle);
    setSelectedEstado(proceso.estado_detalle);
    setSelectedTipoProceso(proceso.tipo_proceso_detalle);
    setFinalidad(proceso.finalidad);
    //alert("proceso.responsable_detalle: " + JSON.stringify(proceso.responsable_detalle));
    const { usuario, grupo } = proceso.responsable_detalle;
    if (usuario) {
      setResponsable(usuario);
      setTipoResponsable("USUARIO");
    } else if (grupo) {
      setResponsable(grupo);
      setTipoResponsable("GRUPO");
    }
    setRespAsesor(proceso.resp_asesor_detalle);
    setRespAsistente(proceso.resp_asistente_detalle);
    setRespOperador(proceso.resp_operador_detalle);
    setApoderado(proceso.apoderado_detalle);
    setEtiqueta(proceso.etiqueta);
    setPrioridad(proceso.prioridad);
    setPeso(proceso.peso);
    setSeguimiento(proceso.seguimiento || "");
    setFechaAdmision(proceso.fecha_admision);
    setFechaAceptacion(proceso.fecha_aceptacion);
    setFechaDesignacion(proceso.fecha_designacion);
    setFechaValidacion(proceso.fecha_validacion);
    setFechaActuaAcreencias(proceso.fecha_actua_acreencias);
    setFechaSuspension(proceso.fecha_suspension);
    //setFechaDesistimiento(proceso.fecha_desistimiento);
  };

  useEffect(() => {
    if (proceso) {
      fetchDatosProceso(proceso);
    }
  }, [proceso]);

  const isNonWorkingDay = (date) => {
    return (
      dayjs(date).day() === 0 ||
      dayjs(date).day() === 6 ||
      diasFestivos?.includes(dayjs(date).format("YYYY-MM-DD"))
    );
  };

  const subtractBusinessDays = (date, days) => {
    let result = dayjs(date);
    let count = 0;
    while (count < days) {
      result = result.subtract(1, "day");
      if (!isNonWorkingDay(result)) {
        count++;
      }
    }
    return result;
  };

  const handleFechaAdmisionChange = (newValue) => {
    const nuevaFechaAdmision = dayjs(newValue);
    setFechaAdmision(nuevaFechaAdmision);

    if (nuevaFechaAdmision.isValid()) {
      setFechaAceptacion(subtractBusinessDays(nuevaFechaAdmision, 1).format("YYYY-MM-DD"));
      setFechaDesignacion(subtractBusinessDays(nuevaFechaAdmision, 2).format("YYYY-MM-DD"));
      setFechaValidacion(subtractBusinessDays(nuevaFechaAdmision, 3).format("YYYY-MM-DD"));
    }
  };

  const handleTipoResponsableChange = (event) => {
    setTipoResponsable(event.target.value);
    setResponsable(null); // Limpiar la selección actual
  };

  const guardarCambios = async () => {
    if (selectedEstado == null) {
      setError("Debes registrar un Estado.");
      return false;
    }
    if (selectedSede == null) {
      setError("Debes registrar una Sede.");
      return false;
    }
    if (selectedTipoProceso == null) {
      setError("Debes registrar un Tipo de Proceso.");
      return false;
    }
    if (responsable == null || respAsesor == null) {
      setError("Debes registrar un Responsable y un Responsable Asesor.");
      return false;
    }
    const confirmacion = window.confirm(`¿Está seguro(a) de que desea clasificar el Proceso?`);
    if (!confirmacion) return;
    const datos = {
      operacion: "CLASIFICAR_PROCESO",
      id_proceso: proceso.id,
      sede: selectedSede,
      auto_admision: autoAdmision,
      estado: selectedEstado,
      tipo_proceso: selectedTipoProceso,
      finalidad: finalidad,
      responsable: {
        tipo: tipoResponsable,
        id_usuario: tipoResponsable === "USUARIO" ? responsable?.id : null,
        str_grupo: tipoResponsable === "GRUPO" ? responsable?.name : null,
      },
      resp_asesor: respAsesor,
      resp_asistente: respAsistente,
      resp_operador: respOperador,
      apoderado: apoderado,
      etiqueta: etiqueta,
      prioridad: prioridad,
      peso: peso,
      seguimiento: seguimiento,
      fecha_admision: fechaAdmision,
      fecha_aceptacion: fechaAceptacion,
      fecha_designacion: fechaDesignacion,
      fecha_validacion: fechaValidacion,
      fecha_actua_acreencias: fechaActuaAcreencias,
      fecha_suspension: fechaSuspension,
      //fecha_desistimiento: fechaDesistimiento,
    };
    //alert("datos.finalidad: " + JSON.stringify(datos.finalidad));
    try {
      setLoading(true);
      const response = await ProcesosApi.operarProceso(datos);
      return response.status === 201;
    } catch (error) {
      console.error("Error al guardar los datos del Proceso:", error);
      setError(obtenerMensajeError(error, "Error al guardar los datos del Proceso."));
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleGeneratePdfGestion = async () => {
    if (!proceso?.identificador) return;
    const cambiosGuardados = await guardarCambios();
    if (!cambiosGuardados) {
      alert("No se pueden generar los PDFs porque hubo un error al guardar los datos.");
    }
    try {
      setIsGeneratingPdf(true);
      setLoading(true);
      const eliminarSiExiste = async (tipo) => {
        const anexoResponse = await ProcesosApi.obtenerAnexoProcesoByTipo(proceso.id, {
          tipo_anexo: tipo,
        });
        const anexo = anexoResponse.data;
        if (anexo != undefined && !anexoResponse.data.error) {
          await ProcesosApi.eliminarAnexoProceso(proceso.id, anexo.id);
        }
      };
      const generarPdf = async (tipoDoc, tipoAnexo, nombreArchivo, descArchivo) => {
        const resp = await PDFApi.generateDocument(tipoDoc, proceso.id);
        const blob = new Blob([resp.data], { type: "application/pdf" });
        const formData = new FormData();
        formData.append("file", blob, nombreArchivo);
        formData.append("file_type", "proceso");
        formData.append("proceso_id", proceso.identificador);
        formData.append("registrar_anexo", "true");
        formData.append("tipo_anexo", tipoAnexo);
        formData.append("nombre_anexo", descArchivo);
        await BucketApi.uploadFile(formData);
      };
      await eliminarSiExiste("PDF_DESIGNACION");
      await generarPdf(
        "designacionProceso",
        "PDF_DESIGNACION",
        "pdf_designacion.pdf",
        "Designación Proceso"
      );
      await eliminarSiExiste("PDF_ACEPTACION");
      await generarPdf(
        "aceptacionCargo",
        "PDF_ACEPTACION",
        "pdf_aceptacion.pdf",
        "Aceptación Proceso"
      );
      await eliminarSiExiste("PDF_ADMISION");
      await generarPdf("admisionProceso", "PDF_ADMISION", "pdf_admision.pdf", "Admisión Proceso");
      await eliminarSiExiste("PDF_ACTUALIZACION_ACREENCIAS");
      await generarPdf(
        "actualizacionAcreencias",
        "PDF_ACTUALIZACION_ACREENCIAS",
        "pdf_actualizacion_acreencias.pdf",
        "Actualización Proceso"
      );
    } catch (error) {
      console.error("Error en el proceso de generación de los PDF's de Gestión:", error);
    } finally {
      setIsGeneratingPdf(false);
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const ok = await guardarCambios();
      if (ok) {
        alert("Operación realizada con éxito");
        resetState();
        onSuccess();
      }
    } catch (error) {
      console.error("Error al guardar los cambios: ", error);
    } finally {
      setLoading(false);
    }
  };

  const resetState = () => {
    setError(undefined);
    setProceso(null);
    setSedes([]);
    setFinalidad("");
    setAsesores([]);
    setAsistenes([]);
    setOperadores([]);
    setApoderados([]);
    setSelectedSede(null);
    setSelectedEstado(null);
    setSelectedTipoProceso(null);
    setTipoResponsable("");
    setResponsable(null);
    setRespAsesor(null);
    setRespAsistente(null);
    setRespOperador(null);
    setApoderado(null);
    setEtiqueta("");
    setPrioridad("");
    setPeso(1);
    setSeguimiento("");
  };

  const hCClose = () => {
    resetState();
    onClose();
  };

  const formatDate = (dateString) => {
    //alert("dateString: " + JSON.stringify(dateString));
    if (!dateString) return "No tiene.";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <Backdrop open={loading} style={{ zIndex: 9999, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog open={open} onClose={hCClose} maxWidth="large" fullWidth>
        <DialogTitle>
          <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={4}>
              <h2>CLASIFICAR</h2>
              <h3>PROCESO: {proceso ? proceso.identificador : "No tiene Proceso"}</h3>
            </Grid>
            <Grid item size={4}>
              <SuiButton
                variant="gradient"
                buttonColor="dark"
                disabled={proceso?.notificado || isGeneratingPdf}
                onClick={handleGeneratePdfGestion}
                startIcon={<PictureAsPdfIcon />}
              >
                {isGeneratingPdf ? (
                  "Generando..."
                ) : (
                  <span style={{ display: "inline-block", textAlign: "center" }}>
                    Generar PDF&lsquo;s Gestión
                    <br />
                    <span style={{ fontSize: "0.60rem" }}>
                      (Admisión, Actua. Acreencias, Designación y Aceptación)
                    </span>
                  </span>
                )}
              </SuiButton>
            </Grid>
            <Grid size={4}>
              <Card
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor:
                    proceso?.dias_habiles_restantes > 40
                      ? "#43a047" // Verde
                      : proceso?.dias_habiles_restantes > 20
                      ? "#f39c12" // Naranja
                      : "#e53935", // Rojo
                  color: "white",
                  padding: 1,
                  borderRadius: 2,
                  boxShadow: 4,
                  height: "100%",
                }}
              >
                <Box sx={{ p: 0.1, textAlign: "center" }}>
                  <SuiTypography variant="subtitle1" fontWeight="bold" sx={{ lineHeight: 1.7 }}>
                    Días Restantes: {proceso?.dias_habiles_restantes}
                  </SuiTypography>
                  <SuiTypography
                    variant="caption"
                    fontWeight="bold"
                    sx={{ lineHeight: 1.5, display: "block" }}
                  >
                    Fecha Admisión: {formatDate(proceso?.fecha_admision)}
                  </SuiTypography>
                  {proceso?.prorrogas?.length > 0 && (
                    <Box sx={{ textAlign: "center" }}>
                      {proceso?.prorrogas.map((prorroga, index) => (
                        <SuiTypography
                          key={index}
                          variant="caption"
                          sx={{
                            display: "block",
                            lineHeight: 1.2,
                            fontSize: "0.7rem",
                          }}
                        >
                          #{prorroga.orden}: +{prorroga.cantidad_dias}d (
                          {formatDate(prorroga.fecha_creacion)})
                        </SuiTypography>
                      ))}
                    </Box>
                  )}
                </Box>
              </Card>
            </Grid>
          </Grid>
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent sx={{ padding: "1px 16px" }}>
            <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={12}>
                {error && (
                  <Alert severity="error" sx={{ mb: 1 }}>
                    {error}
                  </Alert>
                )}
              </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={3}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Auto Admisión *
                </SuiTypography>
                <SuiBox mb={0} display="flex" alignItems="center" gap={1}>
                  <SuiTypography variant="h6" fontWeight="bold">
                    AUTO_No_
                  </SuiTypography>
                  <SuiInput
                    name="autoAdmision"
                    placeholder="Ingrese sólo el Consecutivo"
                    value={autoAdmision || ""}
                    disabled={proceso?.notificado}
                    onChange={(event) => {
                      setAutoAdmision(event.target.value);
                      setError(undefined);
                    }}
                    sx={{ flex: 1 }} // Esto permite que el input ocupe el espacio disponible
                  />
                </SuiBox>
              </Grid>
              <Grid size={3}>
                <SuiBox mb={0}>
                  <SuiTypography variant="h6" fontWeight="bold">
                    Estado *
                  </SuiTypography>
                  <Autocomplete
                    disablePortal
                    options={estadosProceso || []}
                    getOptionLabel={(option) => option?.nombre || ""}
                    sx={{ mb: 3 }}
                    renderInput={(params) => <TextField {...params} />}
                    value={selectedEstado}
                    onChange={(_, newValue) => setSelectedEstado(newValue)}
                  />
                </SuiBox>
              </Grid>
              <Grid size={3}>
                <SuiBox mb={0}>
                  <SuiTypography variant="h6" fontWeight="bold">
                    Sede *
                  </SuiTypography>
                  <Autocomplete
                    disablePortal
                    options={sedes || []}
                    getOptionLabel={(option) => option?.ciudad || ""}
                    renderInput={(params) => <TextField {...params} />}
                    value={selectedSede}
                    onChange={(_, newValue) => setSelectedSede(newValue)}
                  />
                </SuiBox>
              </Grid>
              <Grid size={3}>
                <SuiBox mb={0}>
                  <SuiTypography variant="h6" fontWeight="bold">
                    Etiqueta
                  </SuiTypography>
                  <SuiInput
                    name="etiqueta"
                    placeholder="Etiquera del Proceso"
                    value={etiqueta}
                    onChange={(e) => setEtiqueta(e.target.value)}
                  />
                </SuiBox>
              </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={2}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Tipo Responsable *
                </SuiTypography>
                <Select value={tipoResponsable} onChange={handleTipoResponsableChange}>
                  <MenuItem value="">Seleccione Tipo Responsable</MenuItem>
                  <MenuItem value="USUARIO">Usuario</MenuItem>
                  <MenuItem value="GRUPO">Grupo</MenuItem>
                </Select>
              </Grid>
              <Grid size={4}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Responsable *
                </SuiTypography>
                <Autocomplete
                  disablePortal
                  options={tipoResponsable === "USUARIO" ? usuarios : grupos}
                  getOptionLabel={(option) =>
                    tipoResponsable === "USUARIO"
                      ? option?.nombre_completo || ""
                      : option?.name || ""
                  }
                  sx={{ mb: 3 }}
                  renderInput={(params) => <TextField {...params} />}
                  value={responsable}
                  onChange={(_, newValue) => setResponsable(newValue)}
                />
              </Grid>
              <Grid size={6}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Apoderado Deudor *
                </SuiTypography>
                <Autocomplete
                  disablePortal
                  options={apoderados || []}
                  getOptionLabel={(option) => option?.nombre_completo}
                  sx={{ mb: 3 }}
                  renderInput={(params) => <TextField {...params} />}
                  value={apoderado}
                  onChange={(_, newValue) => setApoderado(newValue)}
                />
              </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={3}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Resp. Operador *
                </SuiTypography>
                <Autocomplete
                  disablePortal
                  options={operadores || []}
                  getOptionLabel={(option) => option?.nombre_completo}
                  sx={{ mb: 3 }}
                  renderInput={(params) => <TextField {...params} />}
                  value={respOperador}
                  onChange={(_, newValue) => setRespOperador(newValue)}
                />
              </Grid>
              <Grid size={3}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Resp. Asesor *
                </SuiTypography>
                <Autocomplete
                  disablePortal
                  options={asesores || []}
                  getOptionLabel={(option) => option?.nombre_completo}
                  sx={{ mb: 3 }}
                  renderInput={(params) => <TextField {...params} />}
                  value={respAsesor}
                  onChange={(_, newValue) => setRespAsesor(newValue)}
                />
              </Grid>
              <Grid size={3}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Resp. Asistente *
                </SuiTypography>
                <Autocomplete
                  disablePortal
                  options={asistentes || []}
                  getOptionLabel={(option) => option?.nombre_completo}
                  sx={{ mb: 3 }}
                  renderInput={(params) => <TextField {...params} />}
                  value={respAsistente}
                  onChange={(_, newValue) => setRespAsistente(newValue)}
                />
              </Grid>
              <Grid size={3}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Finalidad
                </SuiTypography>
                <Select
                  value={finalidad}
                  onChange={(event) => setFinalidad(event.target.value)}
                  displayEmpty
                  fullWidth
                >
                  <MenuItem value="LIQUIDACION">Liquidación</MenuItem>
                  <MenuItem value="ACUERDO">Acuerdo</MenuItem>
                  <MenuItem value="OTRO">Otro</MenuItem>
                </Select>
              </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={3}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Fecha Admisión *
                </SuiTypography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    name="fecha_admision"
                    value={fechaAdmision ? dayjs(fechaAdmision) : null}
                    onChange={handleFechaAdmisionChange}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </Grid>
              <Grid size={3}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Fecha Aceptación *
                </SuiTypography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    name="fecha_aceptacion"
                    value={fechaAceptacion ? dayjs(fechaAceptacion) : null}
                    onChange={(newValue) => setFechaAceptacion(newValue)}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </Grid>
              <Grid size={3}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Fecha Designación *
                </SuiTypography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    name="fecha_designacion"
                    value={fechaDesignacion ? dayjs(fechaDesignacion) : null}
                    onChange={(newValue) => setFechaDesignacion(newValue)}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </Grid>
              <Grid size={3}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Fecha Radicación (Validación) *
                </SuiTypography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    name="fecha_validacion"
                    value={fechaValidacion ? dayjs(fechaValidacion) : null}
                    onChange={(newValue) => setFechaValidacion(newValue)}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={3}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Fecha Actualizacion Acreencias *
                </SuiTypography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    name="fecha_actua_acreencias"
                    value={fechaActuaAcreencias ? dayjs(fechaActuaAcreencias) : null}
                    onChange={(newValue) => {
                      if (newValue) {
                        setFechaActuaAcreencias(dayjs(newValue).format("YYYY-MM-DD"));
                      } else {
                        setFechaActuaAcreencias(null);
                      }
                    }}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={12}>
                <SuiTypography variant="h6" fontWeight="bold">
                  Seguimiento
                </SuiTypography>
                <SuiInput
                  name="seguimiento"
                  placeholder="Seguimiento del Proceso"
                  multiline
                  rows={4}
                  value={seguimiento}
                  onChange={(e) => setSeguimiento(e.target.value)}
                  fullWidth
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <SuiButton onClick={hCClose} buttonColor="light">
              Cancelar
            </SuiButton>
            <SuiButton type="submit" variant="gradient" buttonColor="dark">
              CLASIFICAR
            </SuiButton>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

ClasificarProcesoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  procesoIdentificador: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default ClasificarProcesoModal;
